import * as R from 'ramda'
import * as recompose from 'recompose'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'

import * as jurisdiction from '@rushplay/compliance/jurisdiction'
import { withTranslate } from '@rushplay/i18n'

import * as configuration from '../configuration'
import { getTranslationKey } from '../utils/brand-translation-prefix'

import { StaticPage as Component } from './static-page'

function mapStateToProps(state, props) {
  const licenseId = jurisdiction.getLicense(state.jurisdiction)
  const brand = configuration.getBrand(state.configuration)

  return {
    title: props.translate(getTranslationKey(brand, 'terms-conditions.title')),
    content: props.translate(
      getTranslationKey(brand, `terms-conditions.${licenseId}.content`),
      {
        logoImageSrc: props.translate(
          getTranslationKey(brand, 'terms-and-conditions.general.license-logo')
        ),
      }
    ),
  }
}

const connector = R.compose(
  recompose.setPropTypes({
    translate: PropTypes.func.isRequired,
  }),
  withTranslate,
  connect(mapStateToProps)
)

export const TermsPage = connector(Component)
